import { ref } from "vue";

// Reactive state
const isMobile = ref(false);
const isMobileSidebarOpen = ref(false);

// Breakpoint configuration
const MOBILE_BREAKPOINT = 850;

// Check if current screen size is mobile
const checkMobile = () => {
  const wasMobile = isMobile.value;
  isMobile.value = window.innerWidth <= MOBILE_BREAKPOINT;

  // If switching from mobile to desktop, close sidebar
  if (wasMobile && !isMobile.value) {
    isMobileSidebarOpen.value = false;
  }
};

// Handle window resize
const handleResize = () => {
  checkMobile();
};

// Initialize the service immediately
const initializeResponsive = () => {
  checkMobile();
  window.addEventListener("resize", handleResize);
};

// Toggle mobile sidebar
const toggleMobileSidebar = () => {
  isMobileSidebarOpen.value = !isMobileSidebarOpen.value;
};

// Close mobile sidebar
const closeMobileSidebar = () => {
  isMobileSidebarOpen.value = false;
};

// Initialize immediately
initializeResponsive();

// Composable function
export function useResponsive() {
  return {
    isMobile,
    isMobileSidebarOpen,
    toggleMobileSidebar,
    closeMobileSidebar,
    MOBILE_BREAKPOINT,
  };
}

// Export reactive refs for direct access (if needed)
export {
  isMobile,
  isMobileSidebarOpen,
  toggleMobileSidebar,
  closeMobileSidebar,
};
